export default __webpack_public_path__ + "static/14-4ae7a7f203258bf7e2bdc6e06f89b080.png";